import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api/client';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';
import type { QbClass } from '@/types/settings';

/**
 * Fetch the QBO Classes (org-level transaction-line classification). The
 * backend caches the response for 10 minutes. Used to populate the GL Class
 * picker.
 *
 * Pass `{ enabled: false }` to skip the fetch when QBO is not connected.
 */
export function useChartOfClasses(options?: { enabled?: boolean }) {
  return useApiQuery<QbClass[]>({
    queryKey: settingsKeys.qbClasses(),
    queryFn: () => apiGet<QbClass[]>(operationsClient, settingsEndpoints.qbClasses()),
    showErrorToast: false,
    enabled: options?.enabled,
    staleTime: 10 * 60 * 1000, // backend cache is 10min — match it
  });
}
